import { IResortPageSnowInfo, OpenFlag } from 'api/resort/types';

export const useIsPermanentlyClosed = (resort : IResortPageSnowInfo) => resort.status.openFlag === OpenFlag.PermanentlyClosed;
